import { render, staticRenderFns } from "./lrTenantCompanyId.vue?vue&type=template&id=4a19c5b4&"
import script from "./lrTenantCompanyId.vue?vue&type=script&lang=js&"
export * from "./lrTenantCompanyId.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports